/**
 * PostInfoPannel 骨架屏组件
 *
 * CLS 优化：在评论数据加载完成前显示骨架屏，与实际组件同帧切换
 */
import { Skeleton } from 'antd';
import { cn } from '@/lib/utils';

interface PostInfoPannelSkeletonProps {
  /** 是否为移动端预览模式 */
  isMobilePreview?: boolean;
}

export default function PostInfoPannelSkeleton({ isMobilePreview = false }: PostInfoPannelSkeletonProps) {
  // 移动端预览只显示3条，完整版显示15条
  const itemCount = isMobilePreview ? 3 : 15;

  return (
    <div
      className={cn(
        'w-full flex flex-col border border-gray-200 rounded-lg overflow-hidden bg-white shadow-sm h-full',
        'max-md:border-none max-md:shadow-none'
      )}
    >
      {/* 头部：评论数 + 搜索框 */}
      <div className="p-4 bg-white max-md:p-0 max-md:pb-2.5 border-b border-gray-200">
        <div className="flex flex-col gap-2">
          {/* 评论数 */}
          <div className="flex items-center gap-2">
            <Skeleton.Avatar active size={20} shape="square" />
            <Skeleton.Input active style={{ width: 60, height: 20 }} />
          </div>
          {/* 搜索框和导出按钮 - 移动端预览不显示 */}
          {!isMobilePreview && (
            <div className="relative flex items-center justify-between">
              <Skeleton.Input active style={{ width: 200, height: 36, borderRadius: 8 }} />
              <Skeleton.Button active style={{ width: 80, height: 36 }} />
            </div>
          )}
        </div>
      </div>

      {/* 评论列表骨架 */}
      <div className="flex-1 overflow-hidden">
        {Array.from({ length: itemCount }, (_, index) => (
          <div key={index} className="p-4 max-md:px-0 max-md:py-2.5">
            <div className="flex items-start gap-3">
              {/* 用户头像 */}
              <Skeleton.Avatar active size={40} />

              {/* 评论内容 */}
              <div className="flex-1 min-w-0">
                <div className="flex flex-col gap-1.5">
                  {/* 用户名和时间 */}
                  <div className="flex items-center gap-2">
                    <Skeleton.Input active style={{ width: 100, height: 16 }} />
                    <Skeleton.Input active style={{ width: 80, height: 14 }} />
                  </div>
                  {/* 评论文本 */}
                  <Skeleton.Input active style={{ width: '100%', height: 16 }} />
                  <Skeleton.Input active style={{ width: '70%', height: 16 }} />
                  {/* 点赞数 */}
                  <div className="flex items-center gap-4 mt-1">
                    <Skeleton.Input active style={{ width: 50, height: 14 }} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* 底部按钮区域骨架 */}
      <div className="h-[60px] border-t flex items-center justify-center">
        <div className="p-4 text-center max-md:px-0 max-md:py-2.5 w-full">
          <div className="w-[80%] mx-auto h-[40px] bg-gray-200 rounded animate-pulse" />
        </div>
      </div>
    </div>
  );
}
